import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthenticationService } from 'src/app/shared/services/authentication/authentication.service';
import * as authConsts from '../auth-constants'
import { ToastService } from 'src/app/shared/services/common/toast.service';
import { AuthConnectService } from '../service/auth-connect.service';
import { MsgService } from 'src/app/shared/services/msg.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  @Input() userProfile: { otp: string, email: string } = { otp: '', email: '' };
  @Input() page: any = 'otp';
  @Output() routing = new EventEmitter<string>();
  @Output() pass_check = new EventEmitter<any>();
  @Output() toast = new EventEmitter<any>();
  @Output() updatePageConfig = new EventEmitter<any>();
  @ViewChild('authForm') signInForm!: NgForm;
  @Input() checkEmail!: (x: string) => Promise<boolean>;
  isValid:boolean=false;

  constructor(private readonly authService: AuthenticationService,private toastService: ToastService, private authConnectService:AuthConnectService, private messageService: MsgService) { }
  navigate(url: string) {
    this.routing.emit(url);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async onSubmit() {
    if (this.page == 'forgotpass') this.sendOTP();
    if (this.page == 'otp') {
      this.page = 'updatepass';
      this.updatePageConfig.emit(this.page);
    }
  }
  otpInputConfig = authConsts.otpInputConfig;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleOtpChange(value: string[]): void {
    this.isValid = false
  }

  handleFillEvent(value: string): void {
    this.isValid = true
    this.userProfile.otp = value;
  }

  async sendOTP() {
    const response = await this.authService.SendPasswordChangeConfirmationCode(
      this.userProfile.email
    );
    if (response === "success") {
      this.page = 'otp';
      this.updatePageConfig.emit(this.page);
    }else{
      let msgText = response
      if((response + '')?.includes('LimitExceededException')) msgText = 'Too many password reset requests. Please wait a little while before trying again.'
      this.toastService.setToast({
        ...authConsts.error_msg,
        heading: 'Error',
        text: msgText
      })
    }
  }

  async updatePassword(){
    const isPasswordUpdated = await this.authService.updatePassword(this.userProfile)
    if(!isPasswordUpdated?.success) return
    this.messageService.success('Password updated successfully')
    this.authConnectService.userSignIn(isPasswordUpdated.email, isPasswordUpdated.password)
  }

  isFormInValid(isValid:boolean|null):boolean{
    return isValid || false
  }
}
